// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","StrollerBoxWidget":"bfl_a bii_tr","StrollerBoxWidget__imageCounselling":"bfl_b bii_kg"};